import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../EditProfile/EditProfile.css";
import { getUserById, UpdateUser } from "../api/api";
import { environment } from "../../environments/environments";
import Swal from "sweetalert2";
import { RiEditBoxFill } from "react-icons/ri";
import footerlogo from "../../assets/images/Logo.png";

const EditProfile = () => {
  const navigate = useNavigate();
  const [userdata, setUserdata] = useState({});
  const [isProfileImageVisible, setIsProfileImageVisible] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("currentUser"));
        const _id = userData?.id || userData?._id;
        if (_id) {
          const response = await getUserById({ user_id: _id });
          setUserdata(response.data);
          setIsProfileImageVisible(
            response.data.pre_consent_for_displaying_images
          );
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, []);

  const handleSubmit = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("currentUser"));
      const _id = userData?.id || userData?._id;
      const payload = {
        user_id: _id,
        pre_consent_for_displaying_images: !isProfileImageVisible,
      };
      const response = await UpdateUser(payload);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.message,
          confirmButtonColor: "#3085d6",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops!",
          text: response.message,
          confirmButtonColor: "#d33",
        });
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  return (
    <div className="edit-profile-scroll-wrapper">
      <div className="edit-profile">
        <div className="editsection">
          <div className="profilemain">
            <div className="profilesub1">
              <img src={footerlogo} alt="logo" className="footerImage" />
            </div>
            <div className="profilesub2">
              <div className="editheadingtext-editButton">
                <div className="basicDetailText">
                  <h2 className="Edit-name-heading">
                    <DetailRow value={userdata?.name} />
                  </h2>
                </div>
                <button
                  onClick={() => navigate("/Sidebar/UserBasicDetailsEdit")}
                  className="Editbtn"
                >
                  <RiEditBoxFill /> Edit
                </button>
              </div>
              <div className="editdetail-container">
                {/* <DetailRow label="Name" value={userdata?.name} /> */}
                <DetailRow label="Gender" value={userdata?.gender} />
                <DetailRow label="Date of Birth" value={userdata?.dob} />
                <DetailRow label="Phone No." value={userdata?.phone} />
                <DetailRow label="Email" value={userdata?.email} />
                <DetailRow label="Profession" value={userdata?.profession} />
                <DetailRow label="Address" value={userdata?.address} />
              </div>
            </div>
          </div>
        </div>

        <div className="editsection-checkbox">
          <div className="editdetail-container">
            <label className="checkbox-div">
              <h2 className="Edit-heading-text">
                {" "}
                Display my profile images to others
              </h2>
              <input
                type="checkbox"
                checked={isProfileImageVisible}
                onChange={() => {
                  setIsProfileImageVisible(!isProfileImageVisible);
                  handleSubmit();
                }}
              />
            </label>
          </div>
        </div>
        <div className="editsection">
          <div className="editheadingtext-editButton">
            <div className="basicDetailText">
              <h2 className="Edit-heading-text">Selected Interests</h2>
            </div>
            <button
              onClick={() => navigate("/Sidebar/EditInterest")}
              className="Editbtn"
            >
              <RiEditBoxFill /> Edit
            </button>
          </div>
          <div className="editdetail-container">
            <div className="interest-item-all">
              {userdata.user_interests_list?.length > 0 ? (
                userdata.user_interests_list.map((interest, index) => (
                  <div key={index} className="interest-item">
                    <span className="interest-name">{interest.name}</span>
                  </div>
                ))
              ) : (
                <p>No interests selected.</p>
              )}
            </div>
          </div>
        </div>

        <div className="editsection">
          <div className="editheadingtext-editButton">
            <div className="basicDetailText">
              <h2 className="Edit-heading-text">Upload Image</h2>
            </div>
            <button
              onClick={() => navigate("/Sidebar/UserImageEdit")}
              className="Editbtn"
            >
              <RiEditBoxFill /> Edit
            </button>
          </div>
          {userdata.more_images?.length > 0 &&
            userdata.more_images.map((image, index) => (
              <img
                key={index}
                src={`${environment.url}uploads/users/${image}`}
                alt={`User Image ${index + 1}`}
                className="user-profile-image"
              />
            ))}
        </div>
        <div className="editsection">
          <div className="editheadingtext-editButton">
            <div className="basicDetailText">
              <h2 className="Edit-heading-text">Basic Profile</h2>
            </div>
            <button
              onClick={() => navigate("/Sidebar/UpdateuploadProfileDetails")}
              className="Editbtn"
            >
              <RiEditBoxFill /> Edit
            </button>
          </div>
          <div className="editdetail-container">
            <DetailRow
              label="Relationship Status"
              value={userdata?.more_profile_details?.relationship_status}
            />
            <DetailRow
              label="Ethnicity"
              value={userdata?.more_profile_details?.ethnicity}
            />
            <DetailRow
              label="Religion"
              value={userdata?.more_profile_details?.religion}
            />
            <DetailRow
              label="Education Level"
              value={userdata?.more_profile_details?.education_level}
            />
            <DetailRow
              label="Occupation"
              value={userdata?.more_profile_details?.occupation}
            />
            {/* <DetailRow
              label="Annual Income"
              value={userdata?.more_profile_details?.income}
            /> */}
            <DetailRow
              label="Has Children?"
              value={userdata?.more_profile_details?.have_children}
            />
            <DetailRow
              label="Wants Children?"
              value={userdata?.more_profile_details?.want_children}
            />
            <DetailRow
              label="Blood Group"
              value={userdata?.more_profile_details?.blood_group}
            />
            <DetailRow
              label="Cultural Background"
              value={userdata?.more_profile_details?.cultural_background}
            />
            <DetailRow
              label="Hair Color"
              value={userdata?.more_profile_details?.hair_color}
            />
            <DetailRow
              label="Language Spoken"
              value={
                Array.isArray(userdata?.more_profile_details?.language_spoken)
                  ? userdata.more_profile_details.language_spoken.join(", ")
                  : "N/A"
              }
            />
            <DetailRow
              label="Preferred Game Genre"
              value={
                Array.isArray(
                  userdata?.more_profile_details?.preferred_game_genere
                )
                  ? userdata.more_profile_details.preferred_game_genere.join(
                    ", "
                  )
                  : "N/A"
              }
            />
            <DetailRow
              label="Has Smoking Habit?"
              value={userdata?.more_profile_details?.smokes}
            />
            <DetailRow
              label="Has Drinking Habit?"
              value={userdata?.more_profile_details?.drinks}
            />
            <DetailRow
              label="Has Pets?"
              value={userdata?.more_profile_details?.have_pets}
            />
            <DetailRow
              label="Has Pet Allergies?"
              value={userdata?.more_profile_details?.have_pet_allergies}
            />
          </div>
        </div>
        <div className="editsection">
          <div className="editheadingtext-editButton">
            <div className="basicDetailText">
              <h2 className="Edit-heading-text">Love Language Profile</h2>
            </div>
            <button
              onClick={() => navigate("/Sidebar/UpdateUploadMatchPreferences")}
              className="Editbtn"
            >
              <RiEditBoxFill /> Edit
            </button>
          </div>

          <div className="editdetail-container">
            <div className="qa-pair">
              <p className="qa-question">
                How do you prefer to receive love from your partner?
              </p>
              <p className="qa-answer">
                {userdata?.love_language?.preferred_love_receiving_method ||
                  "N/A"}
              </p>
            </div>

            <div className="qa-pair">
              <p className="qa-question">
                What is the most meaningful way for you to show love to someone?
              </p>
              <p className="qa-answer">
                {userdata?.love_language?.preferred_love_giving_method || "N/A"}
              </p>
            </div>

            <div className="qa-pair">
              <p className="qa-question">
                How important is quality time and undivided attention in your
                relationship?
              </p>
              <p className="qa-answer">
                {userdata?.love_language?.importance_of_quality_time || "N/A"}
              </p>
            </div>

            <div className="qa-pair">
              <p className="qa-question">
                How do you feel about expressing affection through words versus
                actions?
              </p>
              <p className="qa-answer">
                {userdata?.love_language?.words_vs_actions_affection || "N/A"}
              </p>
            </div>

            <div className="qa-pair">
              <p className="qa-question">
                What helps you feel most supported and cared for during
                stressful times?
              </p>
              <p className="qa-answer">
                {userdata?.love_language?.stress_support_preference || "N/A"}
              </p>
            </div>
          </div>
        </div>

        <div className="editsection ">
          <div
            className="editheadingtext-editButtonlst"
            onClick={() =>
              navigate("/Sidebar/QuestionnaireTab", {
                state: { emailss: userdata?.email },
              })
            }
            style={{ cursor: "pointer" }}
          >
            <div className="basicDetailText">
              <h2 className="Edit-heading-text">Show Questionnaire</h2>
            </div>
            <span className="arrowbtn">&#8250;</span>
          </div>
        </div>

        <div className="editsection ">
          <div
            className="editheadingtext-editButtonlst"
            onClick={() =>
              navigate("/Sidebar/ResetPassword", {
                state: { emailss: userdata?.email },
              })
            }
            style={{ cursor: "pointer" }}
          >
            <div className="basicDetailText">
              <h2 className="Edit-heading-text">Reset Password</h2>
            </div>
            <span className="arrowbtn">&#8250;</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const DetailRow = ({ label, value }) => (
  <div className="editdetail-row">
    <span className="editlabel">{label}</span>
    <span className="editvalue">{value}</span>
  </div>
);

export default EditProfile;
